import React, { useState, useEffect } from 'react';
import axios from '../../api/axios';
import { useNavigate, useParams } from 'react-router-dom';
import { isAxiosError } from 'axios';



const ConcernPolicyForm = () => {
  const [isAgreed, setIsAgreed] = useState(false);

  const handleAgreementChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsAgreed(event.target.checked);
  };

  const navigate = useNavigate();
  const { token } = useParams<{ token: string }>();
  const [userData, setUserData] = useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(`users`, null, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = response.data.data;
        sessionStorage.setItem('userData', JSON.stringify(data));
        setUserData(data);
      } catch (error) {
        if (isAxiosError(error)) {
          if (error.response?.status === 404 || error.response?.status === 400) {
            navigate('/not-found');
          }
        } else {
          console.error('Unexpected error:', error);
        }
      }
    };

    // Cek sessionStorage dulu
    const savedUser = sessionStorage.getItem('userData');
    if (savedUser) {
      setUserData(JSON.parse(savedUser));
    } else if (token) {
      fetchData();
    }
  }, [token]);

  const handleOnSubmit = async () => {
  if (!isAgreed) return;

  try {
    const response = await axios.post(`users/concern-policy`, null, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      navigate('/home');
    }
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response?.status === 404 || error.response?.status === 400) {
        navigate('/not-found');
      }
    } else {
      console.error('Unexpected error:', error);
    }
  }
};


  return (
    <main className="profile-page">
      <section className="px-3 pt-5 pb-10 bg-white">
        <div className="container h-full flex items-center justify-center">
          <div className="w-full">
            <div className="header p-4">
              <h3 className="text-lg font-bold text-center" style={{ fontSize: '18px' }}>
                Kebijakan Privasi
              </h3>
            </div>
                     
            <div className="mt-2 scrollable-content">
              <div className="text-concern p-4 pb-6">
                <p>
                  Saya, {userData && userData.person ? userData.person.name : '' }, nomor kartu {userData && userData.person && userData.person.person_insurance ? userData.person.person_insurance.card_number : ''  } dari {userData && userData.person && userData.person.person_insurance ? userData.person.person_insurance.corporate_name : ''  } yang
                  dengan ini secara sadar dan tanpa paksaan, sudah menyambungkan penggunaan penjaminan
                  kesehatan melalui Link Medis Sehat, dimana saya sudah membaca, memahami, mengerti dan
                  menyetujui sebagai berikut:
                </p>
                <br />
                <table>
                  <tbody>
                    {[
                      'Bahwa Link Medis Sehat adalah aplikasi konsultasi online yang mengumpulkan dokter, dimana dokter yang terdaftar adalah dokter yang bertugas secara pribadi dengan Surat Tanda Registrasi (STR) dan Surat Izin Praktik (SIP) aktif sesuai peraturan yang berlaku.',
                      'Bahwa saya mengizinkan dan memberikan wewenang kepada Link Medis Sehat untuk mengirimkan serta menghubungkan transaksi penggunaan layanan ini dengan asuransi/perusahaan yang saya sambungkan.',
                      'Bahwa saya akan melakukan transaksi dengan sebenar-benarnya sesuai dengan kepemilikan jaminan kesehatan/asuransi yang saya sambungkan. Jika ditemukan saya melakukan penyalahgunaan jaminan kesehatan asuransi/perusahaan yang saya sambungkan, maka saya bersedia menerima resiko yang ditentukan oleh Asuransi/Perusahaan termasuk tidak terbatas pada penggantian kerugian, pinalti penyalahgunaan, dan suspend jaminan kesehatan.',
                      'Bahwa saya mengizinkan dan memberikan wewenang kepada Link Medis Sehat untuk memberikan Seluruh informasi penggunaan/transaksi saya di Link Medis Sehat kepada Kementerian Kesehatan atau kementerian/Lembaga negara/instansi pemerintah lainnya guna menjadi catatan medis nasional, apabila memang diwajibkan berdasarkan peraturan perundangan-undangan yang berlaku.',
                      'Bahwa saya menjamin validitas serta keabsahan identitas/profil diri saya termasuk antara lain hasil Analisa dan hasil diagnosa yang disampaikan kedalam layanan ini.',
                      <>
                          Syarat ketentuan lainnya yang ditentukan oleh Link Medis Sehat{' '}
                          <span
                            onClick={() => navigate('/new-syarat-dan-ketentuan')}
                            className="text-[#34CDD5] cursor-pointer underline"
                          >
                            baca syarat dan ketentuan
                          </span>

                      </>,
                      'Syarat ketentuan lainnya yang ditentukan oleh Asuransi/Perusahaan.',
                    ].map((text, index) => (
                      <tr key={index}>
                        <td style={{ width: '2%', verticalAlign: 'top' }}>
                          <p>{index + 1}.&nbsp;</p>
                        </td>
                        <td style={{ width: '98%' }}>
                          <p>{text}</p>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Checkbox & Submit Button */}
            <div className="fixed-bottom">
              <div className="px-3 flex items-center justify-center my-4">
                <input
                  type="checkbox"
                  name="agreement"
                  id="agreement"
                  className="form-checkbox h-5 w-5 text-blue-600"
                  checked={isAgreed}
                  onChange={handleAgreementChange}
                />
                <label htmlFor="agreement" className="ml-2 block text-sm text-gray-900">
                  Saya setuju dengan kebijakan ini.
                </label>
              </div>

              <div className="m-2 mt-5 grid">
                <button
                  id="submitButton"
                  type="button"
                  className={`w-full px-4 py-2 text-white rounded ${
                    isAgreed ? 'bg-teal-500' : 'bg-gray-400 cursor-not-allowed'
                  }`}
                  disabled={!isAgreed}
                  onClick={handleOnSubmit}
                >
                  Simpan
                </button>
              </div>
            </div>

          </div>
        </div>
      </section>
    </main>
  );
};

export default ConcernPolicyForm;
